function submitBIS() {
  console.log("RUN2");

  const contactForm = document.querySelector('#BIS_form');
  const submitButton = document.getElementById('BISSubmit');
  
  const WebhookUrl = "https://api.retool.com/v1/workflows/2c4e9561-12b8-4e8d-aaec-4ca135368fc1/startTrigger?workflowApiKey=retool_wk_0d3c392d8f8846839e5478b33551fb02";

  let submitted = false;
  contactForm.addEventListener(
    'submit',
    (event) => {
      event.preventDefault();

      // Disable the submit button
      submitButton.disabled = true;

      // Serialize form data
      const formData = new FormData(contactForm);
      const formObject = {};
      formData.forEach((value, key) => {
        formObject[key] = value;
      });

      fetch(
        WebhookUrl,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formObject),
        }
      ).then((response) => {
        console.log('Sending data: Success!', response);
        // Optionally, you can add a small delay before re-enabling the button to handle slow responses
        setTimeout(() => {
          submitButton.disabled = false;
        }, 2000);
      }).catch((error) => {
        console.error('Sending data: Error!', error);
        // Re-enable the button in case of error
        submitButton.disabled = false;
      }).finally(() => {
        // Show the success notice and handle the form and button visibility
        document.getElementById("BIS_form_success_notice").classList.add("show");
        document.getElementById("BISSubmit").classList.add("hide_input");
      });
    },
  );
}
